var VERSION = 1789460829583

export  {
	VERSION
} 
